import { render } from "./SmartcardForgetPassword.vue?vue&type=template&id=5812de80&scoped=true"
import script from "./SmartcardForgetPassword.vue?vue&type=script&lang=js"
export * from "./SmartcardForgetPassword.vue?vue&type=script&lang=js"

import "./SmartcardForgetPassword.vue?vue&type=style&index=0&id=5812de80&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5812de80"

export default script